/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { SmsTimelineMessage } from "./SmsTimelineMessage";

export interface SmsTimelineResponse {
  /** The user's SMS conversation id, or null if they have none */
  sms_conversation_id?: string | null;
  /** Inbound texts merged with outbound SMS notifications, oldest first */
  messages?: SmsTimelineMessage[];
}
